import { render, staticRenderFns } from "./project_in_production_indicator.vue?vue&type=template&id=ce50c4be&"
import script from "./project_in_production_indicator.vue?vue&type=script&lang=js&"
export * from "./project_in_production_indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports